<template>
  <el-container>
    <el-header>
      <el-button style="margin-top: 20px" icon="el-icon-arrow-left" plain @click="back">返回</el-button>
    </el-header>
    <el-main class="reg-main" >
      <el-row><span class="title">手机号注册</span></el-row>
      <el-form style="margin-top: 30px" :model="formData" :rules="rules" ref="registerForm">
        <el-form-item prop="phoneNumber"><el-input placeholder="请输入手机号" v-model="formData.phoneNumber" ></el-input></el-form-item>
        <el-form-item prop="smsCode" style="width: 250px" justify="space-between">
        <el-col :span="12"><el-input placeholder="请输入验证码" v-model="formData.smsCode"></el-input></el-col>
        <el-col :span="12">
          <el-button type="primary" style="text-align: right" v-show="show" @click="getCode">获取验证码</el-button>
          <el-button type="primary" v-show="!show" class="count">{{count}}s后重发</el-button>
        </el-col>
      </el-form-item>
      <el-form-item prop="password"><el-input type="password" placeholder="请输入密码（至少6位）" style="width:250px" v-model="formData.password"></el-input></el-form-item>
      <el-form-item><el-input placeholder="推荐人手机号（非必填）" style="width:250px" v-model="formData.recommend"></el-input></el-form-item>
      <el-form-item><el-button type="primary" style="width:250px;" @click="registerUser" v-loading="registing">注册</el-button></el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Register',
  data () {
    return {
      formData: {
        phoneNumber: '',
        smsCode: '',
        password: '',
        recommend: ''
      },
      show: true,
      count: '',
      timer: null,
      registing: false,
      rules: {
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' },
          { min: 6, message: '密码长度不能少于6个字符', trigger: 'blur' },
          { max: 20, message: '密码长度不能多于20个字符', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入验证码', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    checkPhoneNumberValid () {
      // 请求手机短信验证码
      let phoneNumber = this.$data.formData.phoneNumber
      // 验证手机号码长度
      if (phoneNumber.length !== 11) {
        this.$message({
          message: '手机号码长度错误！',
          type: 'error'
        })
        return false
      }
      // 验证第一位为1
      if (phoneNumber.count > 0) {
        if (phoneNumber.substr(0, 1) === '1') {
          this.$message({
            message: '手机号码格式错误！',
            type: 'error'
          })
          return false
        }
      }
      return true
    },
    getCode () {
      const TIME_COUNT = 60

      let phoneNumberValid = this.checkPhoneNumberValid()
      if (!phoneNumberValid) { return false }

      let postData = {phoneNumber: this.$data.formData.phoneNumber, verifyToken: ''}
      this.$axios.post('/login/getSmsCode', this.$qs.stringify(postData)).then(res => {
        if (res.data['status'] === 200) {
          this.$message({
            message: '短信验证码已发送！',
            type: 'success'
          })
        } else {
          this.$message({
            message: '短信验证码发送失败！',
            type: 'error'
          })
        }
      }).catch(e => {})

      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },

    registerUser () {
      var isValid = true
      this.$refs['registerForm'].validate((valid) => {
        isValid = valid
      })

      if (!isValid) {
        return false
      }

      let phoneNumberValid = this.checkPhoneNumberValid()
      if (!phoneNumberValid) { return false }

      this.$data.registing = true
      let postData = {phoneNumber: this.$data.formData.phoneNumber, password: this.$data.formData.password, smsCode: this.$data.formData.smsCode, recommend: this.$data.formData.recommend}
      this.$axios.post('/login/registerWithSmsCode', this.$qs.stringify(postData)).then(res => {
        this.$data.registing = false
        if (res.data['status'] === 200) {
          this.$store.dispatch('setLogin', 'true')
          this.$message({
            message: '注册成功！',
            type: 'success'
          })
          this.$router.push({name: 'home'})
        } else {
          this.$message.error(res.data['message'])
        }
      }).catch(e => { this.$data.registing = false })
    }
  }
}
</script>

<style>

  .reg-main {
    text-align: center;
    margin: auto;
  }

  .title {
    font-size: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Register.vue